class BaseProvider {
    async initialize() {
        throw new Error('Not implemented');
    }

    async trackPageView() {
        throw new Error('Not implemented');
    }

    async trackEvent(eventName, eventParams) {
        throw new Error('Not implemented');
    }

    async setUserId(userId) {
        throw new Error('Not implemented');
    }

    async setEmail(email) {
        throw new Error('Not implemented');
    }

    async setUserProperties(properties) {
        throw new Error('Not implemented');
    }
}

export default BaseProvider;
